var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"id":"logo","src":require("../assets/static-logo.png"),"alt":"SkitMe Logo"}}),_c('div',{attrs:{"id":"content"}},[_c('transition',{attrs:{"name":"slide"}},[_c(_vm.activeComponent,{tag:"component"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }